import apiRequest from '../../utils/api.request';
import config from '../../config.json';
import { logError } from '../../utils/utils'
import { parseQueryString } from '../../utils/utils'
import getHeaderFromParams from '../index';

export async function srGetAppointmentList(requestData) {
  try {
    const url = config.covid_vacc_base_url + "booking/v2/appointment_list/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}

export async function srCancelAppointment(requestData) {
  try {
    const url = config.covid_vacc_base_url + "booking/v2/cancel_appointment/";
    const params = parseQueryString()
    const reqData = {
      ...getHeaderFromParams(params),
      ...requestData
    }
    const data = await apiRequest(
      url,
      reqData,
      true
    )
    return new Promise((resolve) => {
      resolve({ ...data, apiResponseCode: 'success' })
    })
  } catch (error) {
    logError(error)
    return new Promise((resolve, reject) => {
      reject(error)
    })
  }
}